<template>
  <div class="home">
    <div class="home__newsfeed">
      <div class="newsfeed__list">
        <newsfeed-post
          v-for="post in blogpostsList"
          :key="post.id"
          :post-data="post"
          entity = "Company"
          access-level = "Public"
          :entity-id="0"
          :is-user-logged-in="isUserLoggedIn"
          :id="post.id"
          :editable="false"
          @update-data="fetchBlogposts"
        />
      </div>
    
      <el-divider />
      <div class="newsfeed__pagination">
        <el-button @click="fetchPreviousPosts" :disabled="skip === 0">
          <el-icon><ArrowLeft /></el-icon>
        </el-button>
        <el-button @click="fetchNextPosts" :disabled="blogpostsList?.length < limit">
          <el-icon><ArrowRight /></el-icon>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/common/Icon.vue';
import NewsfeedPost from '../common/NewsfeedPost.vue';
import { getCompanyBlogposts } from '@/api/administration.js';

export default {
  name: 'Home',
  data() {
    return {
      blogpostsList: [],
      skip: 0,
      limit: 10,
    };
  },
  components: {
    Icon,
    NewsfeedPost
  },
  beforeCreate () {
    if (!this.$store.state.user) {
      this.$router.push({ name: 'Login' })
    }
  },
  mounted() {
    this.fetchBlogposts();
  },
  methods: {
    async fetchBlogposts() {
      const { data, success } = await getCompanyBlogposts(this.skip, this.limit);
      if (success) {
        this.blogpostsList = data.items;
      }
    },
    async fetchPreviousPosts() {
      if (this.skip >= this.limit) {
        this.skip -= this.limit;
        await this.fetchBlogposts();
      }
    },
    async fetchNextPosts() {
      this.skip += this.limit;
      await this.fetchBlogposts();
    },
  },
  computed: {
    isAdmin() {
      return false; //this.eventData ? this.eventData.hasAdminRights : false;
    },
    currentUser() {
      return this.$store.state.user;
    },
    isUserLoggedIn() {
      const { currentUser } = this;
      return Boolean(currentUser.userId);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/shared/_globals.scss';

.home {
  &__newsfeed {
  }

  &__add-new {
    width: 100%;
    display: flex;
    align-items: center;
    flex-flow: row nowrap;
    margin-bottom: var(--global-dimension-size-400);

    cursor: pointer;
    padding: 14px 20px;
    box-sizing: border-box;

    color: var(--color-primary-400);
    background-color: var(--color-gray-200);
    border-radius: var(--border-radius-base);

    &:hover {
      background-color: var(--color-gray-300);
    }
  }

  &__add-new-label {
    font-weight: 500;
    margin-left: 16px;
  }
}

.news-item {
  margin-bottom: 20px;
  background-color: var(--color-gray-50);
  padding: var(--global-dimension-size-250);
  border-radius: var(--border-radius-base);

  &__header {
    display: flex;
    flex-flow: row nowrap;
    margin-bottom: var(--global-dimension-size-250);
  }

  &__avatar {
    margin-right: var(--global-dimension-size-200);
  }

  &__header-info {
    line-height: 1.6;
  }

  &__name {
    font-weight: 500;
    font-size: var(--font-size-300);
  }

  &__date {
    font-size: var(--font-size-100);
    color: var(--color-gray-800);
  }

  &__photo {
    display: block;
    max-width: 100%;
    margin-bottom: var(--global-dimension-size-250);
  }

  &__title {
    font-weight: 500;
    font-size: var(--font-size-300);
    line-height: 1.6;
    margin-bottom: var(--global-dimension-size-125);
  }

  &__text {
    line-height: 1.6;
  }

  &__bottom {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    margin-top: var(--global-dimension-size-250);
  }

  &__likes {
    display: flex;
    align-items: center;
    margin-right: var(--global-dimension-size-300);
    cursor: not-allowed;
  }

  &__likes-count {
    margin-left: var(--global-dimension-size-125);
  }

  &__share {
    cursor: not-allowed;
    line-height: 1;
  }

  &__pagination {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    margin-top: var(--global-dimension-size-250);
    align-items: center;
  }
}
</style>
